import { useState } from 'react';
import { GiftIcon } from 'lucide-react';
import { useCartActions } from '../../contexts/StoreContext';
import { useCatalog } from '../../contexts/CatalogContext';
import { policyCopy } from '../../data/policies';
import { euro } from '../../core/format/currency';
import { btnPrimary, choiceState } from '../../ui/styles';
import { sectionHeading } from '../../ui/sections';

/** Cadeaubon: bedrag kiezen en toevoegen. Het middelste bedrag staat voorgeselecteerd. */
export function GiftCardBlock() {
  const {
    add
  } = useCartActions();
  const {
    giftCards
  } = useCatalog();
  const fallback = giftCards[1] ?? giftCards[0];
  const [selected, setSelected] = useState(fallback?.id ?? '');
  const card = giftCards.find(g => g.id === selected) ?? fallback;
  if (!card) return null;
  return <section className="bg-blush py-20 sm:py-24 lg:py-32" aria-labelledby="cadeaubon" data-id="element-8670" data-mp="3lr2rr1r96mpw">
      <div className="mx-auto grid max-w-content items-center gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-8671" data-mp="3pt7fjjv0sp4m">
        <div className="lg:col-span-7" data-id="element-8672" data-mp="37wqfvpogapxv">
          <p className="flex items-center gap-2 text-[14px] text-ink" data-id="element-8673" data-mp="37xs3etmnl4wh">
            <GiftIcon className="h-4 w-4 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-8674" data-mp="32yyrv6qxfnyy" />
            Cadeaubon
          </p>
          <h2 id="cadeaubon" className={`mt-5 max-w-2xl ${sectionHeading} text-ink`} data-id="element-8675" data-mp="3gzhu1x8pnzt7">
            Geef geen product cadeau, geef de keuze
          </h2>
          <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-muted" data-id="element-8676" data-mp="3qvukmm8ylxjq">
            De ontvanger besteedt de bon aan producten of een behandeling in de salon, met gratis huidadvies erbij. Direct per mail,{' '}
            {policyCopy.giftCardValidity.toLowerCase()}.
          </p>
        </div>

        <div className="lg:col-span-5" data-id="element-8677" data-mp="3vmb16f82tzab">
          <div className="bg-shell p-7 lg:p-8" data-id="element-8678" data-mp="3vncq9nlxgmb1">
            <fieldset data-id="element-8679" data-mp="dgycbonnsccn">
              <legend className="type-name text-ink" data-id="element-8680" data-mp="dgg4durmw9ow">Kies een bedrag</legend>
              <div className="mt-4 grid grid-cols-3 gap-2" data-id="element-8681" data-mp="8iepzn55kyjr">
                {giftCards.map(g => {
                const active = g.id === card.id;
                return <button key={g.id} type="button" aria-pressed={active} onClick={() => setSelected(g.id)} className={`py-4 text-center type-name ${choiceState(active)}`} data-id="element-8682" data-mp="328a2awva93oe">
                      {euro(g.price)}
                    </button>;
              })}
              </div>
            </fieldset>
            <button type="button" onClick={() => add(card)} className={`${btnPrimary} mt-5 w-full py-3.5`} data-id="element-8683" data-mp="3pymcyfhwxeio">
              Cadeaubon van {euro(card.price)} toevoegen
            </button>
            <p className="mt-3 text-center text-[13px] text-muted" data-id="element-8684" data-mp="2v9caj2b7zw4">Persoonlijke boodschap toevoegen kan bij het afrekenen.</p>
          </div>
        </div>
      </div>
    </section>;
}